import PublicLayout from "sections/PublicLayout";
import PhotoGallery from "sections/public/PhotoGallery";
import { getCampaings } from "firestoreService";

function Campaign() {
  return (
    <PublicLayout
      eyebrow="A1 Home Tutors"
      title="Campaigns"
      subtitle="Education drives and community programmes we run across Delhi NCR."
    >
      <PhotoGallery
        fetchImages={getCampaings}
        alt="A1 Home Tutors campaign"
        emptyText="No campaigns have been published yet. Please check back soon."
      />
    </PublicLayout>
  );
}

export default Campaign;
